import { isSupported, MemoryStorage } from 'local-storage-fallback'

let storage = null

if (isSupported('localStorage')) {
  storage = window.localStorage
} else {
  storage = new MemoryStorage()
  storage.length = function () {
    return Object.keys(storage._data).length
  }
}

export default storage



// WEBPACK FOOTER //
// ./~/@octadesk/storage/src/storageSelector.js